import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserRestService} from '@core/modules/rest/user/user-rest.service';
import {UserDataModel} from '@core/modules/rest/user/response/user-data.model';
import {UserGenderEnum} from '@core/enums/user-gender.enum';
import {UserNumberOfInjectionsEnum} from '@core/enums/user-number-of-injections.enum';
import {UserItExperienceEnum} from '@core/enums/user-it-experinece.enum';
import {SaveUserPersonalSettingsRequestModel} from '@core/modules/rest/user/request/save-user-personal-settings-request.model';
import {FormControl, FormGroup, AbstractControl, ValidatorFn, ValidationErrors} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-more-info-popup',
    templateUrl: './more-info-popup.component.html',
    styleUrls: ['./more-info-popup.component.scss']
})
export class MoreInfoPopupComponent implements OnInit {
    @Output() closeDialogEvent: EventEmitter<void> = new EventEmitter<void>();

    form: FormGroup;
    userId: string;
    username: string;
    loading = true;
    saveRequest: SaveUserPersonalSettingsRequestModel;

    male = UserGenderEnum.MALE;
    female = UserGenderEnum.FEMALE;
    injectionsNone = UserNumberOfInjectionsEnum.NONE;
    injections1to5 = UserNumberOfInjectionsEnum.INJECTIONS_1_TO_5;
    injections6to10 = UserNumberOfInjectionsEnum.INJECTIONS_6_TO_10;
    injections11to20 = UserNumberOfInjectionsEnum.INJECTIONS_11_TO_20;
    injectionsMoreThan20 = UserNumberOfInjectionsEnum.INJECTIONS_MORE_THAN_20;
    itNone = UserItExperienceEnum.NONE;
    itPoor = UserItExperienceEnum.POOR;
    itPrettyWell = UserItExperienceEnum.PRETTY_WELL;
    itVeryGood = UserItExperienceEnum.VERY_GOOD;

    ageFormControl = new FormControl('', {validators: [this.ageInputInvalid()]});
    betterEyeVisionFormControl = new FormControl('', {validators: [this.visionInputInvalid()]});

    constructor(@Inject(MAT_DIALOG_DATA) userId, private dialog: MatDialogRef<MoreInfoPopupComponent>, private userRestService: UserRestService) {
        this.userId = userId;
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            age: this.ageFormControl,
            betterEyeVision: this.betterEyeVisionFormControl
        });

        this.userRestService.user(this.userId).subscribe((data: UserDataModel) => {
            this.saveRequest = {
                userId: data.userId,
                gender: data.gender,
                age: data.age,
                numberOfInjections: data.numberOfInjections,
                betterEyeVision: data.betterEyeVision,
                itExperience: data.itExperience
            };

            this.username = data.username;
            this.loading = false;

            if (this.saveRequest.age) {
                this.ageFormControl.setValue(this.saveRequest.age);
            }
            if (this.saveRequest.betterEyeVision) {
                this.betterEyeVisionFormControl.setValue(this.saveRequest.betterEyeVision);
            }

        });

        this.ageFormControl.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(value => {
                this.saveRequest.age = value;
            });

        this.betterEyeVisionFormControl.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(value => {
                this.saveRequest.betterEyeVision = value;
            });
    }

    onInjectionChange(selected: UserNumberOfInjectionsEnum): void {
        this.saveRequest.numberOfInjections = selected;
    }

    onGenderChange(selected: UserGenderEnum): void {
        this.saveRequest.gender = selected;
    }

    onItExperienceChange(selected: UserItExperienceEnum): void {
        this.saveRequest.itExperience = selected;
    }

    onUpdateUserPersonal(): void {
        if (!this.form.valid) {
            return;
        }

        this.userRestService.saveProfileSettings(this.saveRequest);
        this.dialog.close();
    }

    private isNumber(item: any): boolean {
        return /^\d+$/.test(item);
    }

    ageInputInvalid(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            const isValid = value.length === 0 || (value >= 1 && value < 130 && this.isNumber(value));
            return isValid ? null : {ageInvalid: true};
        };
    }

    visionInputInvalid(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            const isValid = value.length === 0 || (value > 0 && value <= 100 && this.isNumber(value));
            return isValid ? null : {visionInvalid: true};
        };
    }
}
